import { makeContextModule } from '@cian/react-utils';

import { type MapLayersCenterContext } from '@/microfrontends/map/shared/types/MapLayersCenterContext';

export const {
  Context: { Provider: MapLayersCenterContextProvider },
  useContext: useMapFeaturesContext,
  withContext: withMapFeaturesContext,
} = makeContextModule<MapLayersCenterContext>({
  contextName: 'MapLayersCenterContext',
});
